import useJsonApi from "lib/useJsonApi.js";

function useSessionOrders(sessionUuid) {
  return useJsonApi({
    url: `/api/session/${sessionUuid}/orders`,
  });
}

export default useSessionOrders;
